// extracted by mini-css-extract-plugin
export default {"aside":"PartnersAside_aside__erhTx","name":"PartnersAside_name__6wn7v","tel":"PartnersAside_tel__xa8Jc","email":"PartnersAside_email__7-m4w","link":"PartnersAside_link__4Oxuk"};